module.exports = __webpack_public_path__ + "static/media/logo-fnac--squared.6dc69bba.png";